/* eslint-disable react/display-name */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  max-width: ",
        ";\n  margin: 70px auto;\n  background: #fff;\n  box-shadow: 0 0 30px #444;\n  border-radius: 5px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  padding: 0 25px 25px;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import { Flex, IconButton, Icon, icons, Heading } from '@tapresearch/ui/components';
import ReactModal from 'react-modal';
import styled from 'styled-components';
var Modal = styled(ReactModal)(_templateObject(), function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : '450px';
});
var Body = styled.div(_templateObject1());
export default function(_param) {
    var isOpen = _param.isOpen, onClose = _param.onClose, title = _param.title, children = _param.children, args = _object_without_properties(_param, [
        "isOpen",
        "onClose",
        "title",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(Modal, _object_spread_props(_object_spread({}, args), {
        isOpen: isOpen,
        onRequestClose: onClose,
        style: {
            overlay: {
                zIndex: 1500,
                backgroundColor: 'rgba(50, 50, 50, 0.8)',
                overflow: 'auto',
                overflowY: 'scroll'
            }
        },
        ariaHideApp: false
    }), /*#__PURE__*/ React.createElement(Flex, {
        p: 4,
        align: "center",
        "data-testid": (args || {})['data-testid']
    }, /*#__PURE__*/ React.createElement(Heading, {
        flexGrow: 1,
        fontSize: 'lg',
        fontWeight: '800'
    }, title), /*#__PURE__*/ React.createElement(IconButton, {
        variant: "ghost",
        icon: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 6,
            icon: icons.fi.X
        }),
        onClick: onClose
    })), /*#__PURE__*/ React.createElement(Body, null, children));
};
